export class DeviceDataCollector {
  static collect() {
    return {
      colorDepth: screen.colorDepth,
      javaEnabled: false,
      language: navigator.language || navigator.userLanguage,
      screenHeight: screen.height,
      screenWidth: screen.width,
      timeZoneOffset: new Date().getTimezoneOffset() / 60,

      deviceType3ds: "BROWSER",
      
      userAgent: navigator.userAgent,
      cookiesEnabled: navigator.cookieEnabled,
      doNotTrack: navigator.doNotTrack,
      
      canvasFingerprint: this.getCanvasFingerprint(),
      
      webglVendor: this.getWebGLVendor(),
      webglRenderer: this.getWebGLRenderer(),
      
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      
      maxTouchPoints: navigator.maxTouchPoints || 0,
      deviceMemory: navigator.deviceMemory || null,
      hardwareConcurrency: navigator.hardwareConcurrency || null,
      
      collectedAt: new Date().toISOString()
    };
  }
  
  static getCanvasFingerprint() {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    ctx.textBaseline = 'top';
    ctx.font = '14px Arial';
    ctx.textBaseline = 'alphabetic';
    ctx.fillStyle = '#f60';
    ctx.fillRect(125, 1, 62, 20);
    ctx.fillStyle = '#069';
    ctx.fillText('Canvas fingerprint', 2, 15);
    ctx.fillStyle = 'rgba(102, 204, 0, 0.7)';
    ctx.fillText('Canvas fingerprint', 4, 17);
    return canvas.toDataURL();
  }
  
  static getWebGLVendor() {
    try {
      const canvas = document.createElement('canvas');
      const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
      const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
      return gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL);
    } catch(e) {
      return null;
    }
  }
  
  static getWebGLRenderer() {
    try {
      const canvas = document.createElement('canvas');
      const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
      const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
      return gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
    } catch(e) {
      return null;
    }
  }
}


